export type EventType<T> = { [key: string]: ((data: T) => void)[] };

/**
 * Observer class to subscribe to a specific event
 * @class
 * @template T - The type of the event
 *
 * @example
 * const subscription = observer.subscribe('event', (data) => { });
 * observer.unsubscribe(subscription);
 */
export class Observable<T> {
  private static instance: Observable<any> | null = null;
  events: EventType<T> = {};

  private constructor() {
    this.events = {};
  }

  static getInstance<T>(): Observable<T> {
    if (!Observable.instance) {
      Observable.instance = new Observable<T>();
    }
    return Observable.instance;
  }

  notify(event: string, data?: T): void {
    if (this.events[event]) {
      this.events[event].forEach((callback) => {
        callback(data);
      });
    }
  }

  subscribe(event: string, callback: (data: T) => void): symbol {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
    return Symbol(event);
  }

  unsubscribe(subscription: symbol): void {
    const event = subscription.toString().slice(7, -1);
    if (this.events[event]) {
      delete this.events[event];
    }
  }

  clear(): void {
    this.events = {};
  }
}
